import { render, staticRenderFns } from "./message-list.vue?vue&type=template&id=ddcddb24&scoped=true&"
import script from "./message-list.vue?vue&type=script&lang=js&"
export * from "./message-list.vue?vue&type=script&lang=js&"
import style0 from "./message-list.vue?vue&type=style&index=0&id=ddcddb24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.7_eeqz4xtr3chsfpwu4zsrvzqhvy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddcddb24",
  null
  
)

export default component.exports